import React from "react"
import { ErrorBoundary } from "react-error-boundary"

import { reportBoundaryError } from "shared/lib/rollbar"
import { ErrorFallback } from "./ErrorFallback"

export const ErrorFallbackBoundary = ({ children, height }) => (
  <ErrorBoundary
    onError={reportBoundaryError}
    fallbackRender={(props) => <ErrorFallback {...props} height={height} />}
  >
    {children}
  </ErrorBoundary>
)
